import { FC } from "react";
import img1 from "images/start-earning-today.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";

export interface Section1Props {
  className?: string;
}

const Section1: FC<Section1Props> = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`nc-SectionHero3 mb-80 md:mb-52 bg-black bg-opacity-70 lg:mb-0 relative ${className}`}
      data-nc-id="SectionHero3"
    >
      <div
        className="absolute inset-x-0 top-[20%]  md:top-[20%] lg:top-[15%] text-center flex flex-col items-center  mx-auto space-y-3 lg:space-y-3 xl:space-y-5"
        style={{ zIndex: 1 }}
      >
        <span className="text-3xl lg:text-6xl font-bold  text-center  text-white  bg-opacity-80 px-1  lg:mx-0 mx-4">
          We Manage Your Car,
        </span>
        <span className="text-3xl lg:text-6xl  font-semibold text-center   text-primary-100 bg-opacity-80 px-1 lg:bg-none lg:bg-opacity-0 lg:mx-0 mx-4">
          YOU EARN!
        </span>
        <ButtonPrimary
          onClick={() => {
            navigate("/contact");
          }}
        >
          List Your Car Now
        </ButtonPrimary>
      </div>
      <div className="relative rounded-2xl aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8 ">
        <img
          className="absolute inset-0 w-full rounded-2xl"
          src={img1}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default Section1;
